<div class="portal-select-shell">
    <section class="portal-select-panel" aria-labelledby="portal-select-title">
        <div class="brand">
            @if ($businessLogo()) {
                <div class="business-logo-frame">
                    <img class="business-logo" [src]="$businessLogo()" [alt]="$businessName() || 'Company logo'" />
                </div>
            } @else {
                <div class="business-name">{{ $businessName() || 'Your portal' }}</div>
            }
        </div>

        <div class="intro">
            <p class="eyebrow">Portal access</p>
            <h1 id="portal-select-title">Select your portal</h1>
            <p>Your account is linked to both client and contractor access.</p>
        </div>

        <div class="portal-options">
            @for (option of options; track option._id) {
                <button type="button" class="portal-option" (click)="open(option.path)">
                    <span class="option-icon"><i [class]="option.icon"></i></span>
                    <span class="option-copy">
                        <span class="option-title">{{ option.title }}</span>
                        <span class="option-description">{{ option.description }}</span>
                    </span>
                    <span class="option-action">Continue <i class="fa-regular fa-arrow-right"></i></span>
                </button>
            }
        </div>

        <div class="footer-actions">
            <w-button displayStyle="Tertiary" size="Medium" label="Log out" iconLeft="fa-regular fa-arrow-right-from-bracket" (onClick)="logout()" />
        </div>

        <div class="powered-by">
            <span>Powered by</span>
            <img src="images/workbuddy_full_logo_blue.svg" alt="WorkBuddy" />
        </div>
    </section>
</div>
